<template>
  <span>Input fields cannot be empty. Please fill them</span>
</template>

<script>
export default {
  name: "empoty-fields-error"
};
</script>
